// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {
    Avatar, Stack,
    Tooltip
} from "@mui/material";

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractDetailList} from "./contractDetailListSlice";
import {getContractCdpvList} from "../ContractClient";
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange} from "@mui/material/colors";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractCdpvListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractCdpvList, setContractCdpvList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorCdpvListDrawerState = useSelector((state) => state.contractDetailListSlc.value.cdpvListDrawerState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractCdpvList = () =>
        getContractCdpvList(selectorContractId, 'null')

            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractCdpvList(data);
            });

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractCdpvList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.cdpvListDrawerState)===true]);

    // ******************** END USE EFFECTS *******************


// ***************** BEGIN CONTROLS ***************************

    function closeContractCdpvListDrawer() {
        dispatchData(changeContractDetailList({id: 0, cdpvListDrawerState: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN MISC ***************************

    const renderContractCdpvList = contractCdpvList => {
        if (contractCdpvList.length <= 0) {
            return "No Data";
        }}

    // *************** END MISC *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractCdpvList => [

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            editable: false,
            width: 50,
            hide: true,
        },
        {    field: 'sectionOrdinal',
            headerName: 'Section #',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'sectionName',
            headerName: 'Name',
            description: '',
            sortable: true,
            editable: false,
            width: 500,
        },
        {    field: 'cdpOrdinal',
            headerName: 'CDP Order',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointId',
            headerName: 'DP ID',
            description: '',
            sortable: true,
            editable: false,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: true,
            editable: false,
            width: 300,
            hide: false,
        },
        {    field: 'cdpvOrdinal',
            headerName: 'Order',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {    field: 'cdpvIteration',
            headerName: 'Iteration',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'value',
            headerName: 'Value',
            description: '',
            sortable: true,
            editable: false,
            width: 300,
            hide: false,
        },
        {
            field: 'expressionInd',
            headerName: 'Expression',
            description: '',
            sortable: true,
            editable: false,
            width: 90,
            hide: true,
        },
        {
            // field: 'mockIndicator',
            field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
            headerName: '',
            renderCell: (contractCdpvList) =>
            {
                if((contractCdpvList.row.expressionInd !== null) && (contractCdpvList.row.expressionInd !== '')){
                    return (
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"Value comes from an expression."}>
                            <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                        </Tooltip>)}
             },
            description: '',
            sortable: false,
            width: 50,
        },
        {
            field: 'origin',
            headerName: 'Origin',
            description: '',
            sortable: true,
            editable: false,
            width: 100,
            hide: false,
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1700 },
                }}
                anchor='right'
                // open={true}
                open={selectorCdpvListDrawerState}
                initialState={{open: false}}
                onClose={closeContractCdpvListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractCdpvListDrawer()}>Contract Data Point Value List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                {/*<h4>Value List</h4>*/}
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractCdpvList"}
                    rows={contractCdpvList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractCdpvList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractCdpvList => contractCdpvList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
